__turbopack_context__.v({
  "className": "alegreya_sans_6f70b72f-module__4o7Knq__className",
  "variable": "alegreya_sans_6f70b72f-module__4o7Knq__variable",
});
